import { SkyClubSpendTracker } from '../models/skyclub.interfaces';
import {
  MultipleCards,
  SingleCard,
  UnlimitedAccess75kCard,
  UnlimitedAccessMemberSkyClubCard,
  UsedAllVisitsCard
} from './cards.mocks';

export const SkyClubTrackerSingleCardMocks: SkyClubSpendTracker = {
  headerLogo: {
    alt: 'Skymiles Logo',
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/delta-skyclub-logo.svg'
  },
  cards: SingleCard,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyClubTrackerUsedAllVisitsMocks: SkyClubSpendTracker = {
  headerLogo: {
    alt: 'Skymiles Logo',
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/delta-skyclub-logo.svg'
  },
  cards: UsedAllVisitsCard,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyClubTrackerMultipleCardsMocks: SkyClubSpendTracker = {
  headerLogo: {
    alt: 'Skymiles Logo',
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/delta-skyclub-logo.svg'
  },
  cards: MultipleCards,
  ariaLabels: {
    next: 'Next Card',
    previous: 'Previous Card'
  },
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyClubTrackerUnlimitedAccess75kCardMocks: SkyClubSpendTracker = {
  headerLogo: {
    alt: 'Skymiles Logo',
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/delta-skyclub-logo.svg'
  },
  cards: UnlimitedAccess75kCard,
  disabled: false,
  loaded: true,
  error: undefined
};

export const SkyClubTrackerUnlimitedAccessMemberSkyClubCardMocks: SkyClubSpendTracker =
  {
    headerLogo: {
      alt: 'Skymiles Logo',
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/skyclub/delta-skyclub-logo.svg'
    },
    cards: UnlimitedAccessMemberSkyClubCard,
    disabled: false,
    loaded: true,
    error: undefined
  };
